import { api } from '@/f1/service';
import codes from '@/f1/codes'

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}
});
const i18n_fields = {
  EN: [
    { key: 'id', label: 'No', sortable: false, thStyle: 'width: 5%' },
    // { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 8%' },
    { key: 'created_at', label: 'DateTime', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: 'Action', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: 'Target', sortable: false },
  ],
  KO: [
    { key: 'id', label: 'No', sortable: false, thStyle: 'width: 5%' },
    // { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 8%' },
    { key: 'created_at', label: '시간', sortable: false, thStyle: 'width: 15%' },
    { key: 'action', label: '행동', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: '타겟', sortable: false },
  ]
}

export default {
  props: ['is_main'],
  data : () => {
    return {
      codes,
      so : default_opt(),
      selected : '',
      limit : 10
    }
  },
  computed: {
    rowCount: function() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() { return i18n_fields[this.i18n]; },
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { console.log('WMDS', 'refresh'); this.$refs._list.refresh(); },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        target : 'forgery.detect', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc"}], or : [], and : [{ name : "type", value : "wmds", op : "="}] },
        offset : (this.so.currentPage-1 || 0) * this.limit, limit: this.limit, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if((this.so.sv || '').trim()) { so.body.and = [ { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      return api.wmds.WMDS(so).then(rs => { this.so.totalRows = rs.total; this.model = rs.body; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
    },
    detail(item) { console.log(item); this.$router.push(`domainresult/${item.id}`); },
    hideList: function(e) {
      this.show = !e; console.log('site.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
  	}
  },
  created() { console.log('WMDS', 'integrity.vue', 'created'); },
  destroyed() { console.log('WMDS', 'integrity.vue', 'destroyed'); },
  mounted() { console.log('WMDS', 'integrity.vue', 'mounted'); },
}